import styles from "./QRScan.module.scss"
import Html5QrcodePlugin from "./Html5QrcodePlugin"
import { Html5QrcodeResult } from "html5-qrcode"
import { useLazyGetTechObjByGuidQuery } from "../../redux/api/main"
import { LINK_REGEXP } from "../../utils/constants"
import moment from "moment/moment"
import { setQRScanDate } from "../../redux/slice/object"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Dispatch, SetStateAction } from "react"

interface Props {
  afterScanningFunc?: (time?: string, objectID?: string) => void
  callbackError?: () => void
  afterNavigate?: (obj: string) => void
  nowActiveCamera: number
  setOpen: Dispatch<SetStateAction<boolean>>
  setQrLoading: Dispatch<SetStateAction<boolean>>
  isQrLoading: boolean
  qrIsError: boolean
  setQrIsError: Dispatch<SetStateAction<boolean>>
}

const QRScan3 = ({
  setQrLoading,
  isQrLoading,
  nowActiveCamera,
  qrIsError,
  setQrIsError,
  afterScanningFunc,
  callbackError,
  afterNavigate,
  setOpen,
}: Props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [getTechObjByGuid, { isLoading, isFetching }] = useLazyGetTechObjByGuidQuery()

  const onNewScanResult = (decodedText: string) => {
    if (!decodedText) return
    if (LINK_REGEXP.test(decodedText) && decodedText.includes(window.location.hostname)) {
      window.location.replace(decodedText)
    } else {
      let resultId = decodedText
      if (LINK_REGEXP.test(decodedText)) {
        // вытаскиваем из диплинка guid
        resultId = String(new URLSearchParams(new URL(decodedText).search).get("guid"))
      }
      if (isLoading) return
      if (!resultId || resultId === "null") {
        if (callbackError) callbackError()
        return
      }
      try {
        getTechObjByGuid(resultId)
          .unwrap()
          .then((res) => {
            if (!res?.data?.id) {
              if (callbackError) callbackError()
              return
            }
            const dataCreatedAt = res?.data?.created_at
            const time = dataCreatedAt
              ? moment(dataCreatedAt * 1000).format("DD.MM.YYYY HH:mm")
              : moment().format("DD.MM.YYYY HH:mm")
            if (afterScanningFunc) {
              afterScanningFunc(time, res?.data?.id)
            } else {
              const resDataID = res.data.id
              sessionStorage.setItem("QRScanDate", JSON.stringify(time))
              if (afterNavigate) {
                afterNavigate(`/object/${resDataID}`)
              } else {
                navigate(`/object/${resDataID}`)
              }
            }
          })
          .catch((err) => {
            console.error("catch error QR: ", err)
            if (callbackError) callbackError()
          })
      } catch (err) {
        console.error("catch error QR: ", err)
        if (callbackError) callbackError()
      }
    }
  }

  return (
    <div className={styles.reader}>
      {isFetching ? (
        <div className={styles.loader}>
          <img src="/img/loading.svg" alt="" />
        </div>
      ) : (
        <>
          {!isQrLoading && (
            <div className={styles.loader}>
              <img src="/img/loading.svg" alt="" />
            </div>
          )}
          <Html5QrcodePlugin
            setQrLoading={setQrLoading}
            nowActiveCamera={nowActiveCamera}
            qrCodeSuccessCallback={onNewScanResult}
            qrIsError={qrIsError}
            setQrIsError={setQrIsError}
            callbackError={callbackError}
          />
        </>
      )}
    </div>
  )
}

export default QRScan3
